import CenteredContent from 'components/CenteredContent/CenteredContent';

const DesignForItem = () => {
  return <li className="design-for-item skeleton" />;
};

const DesignForSectionSkeleton = () => {
  const designForItems = Array.from({ length: 8 }, (_, index) => <DesignForItem key={index} />);

  return (
    <CenteredContent>
      <section className="title skeleton" />
      <ul className="design-for">{designForItems}</ul>
    </CenteredContent>
  );
};

export default DesignForSectionSkeleton;
